import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';

interface SalesRep {
  salesRepName: string;
}

export interface Props {
  children?: FC;
  item?: SalesRep;
}

const SalesRepNameCell: FC<Props> = ({ item = { salesRepName: '' } }) => {
  const { salesRepName } = item;
  return (
    <DataTableCell title={salesRepName || ''}>
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {salesRepName}
      </div>
    </DataTableCell>
  );
};

export default SalesRepNameCell;
